import {_Sitemap} from '@localization/siteMap/breadcrumbs/_Sitemap.ts';
import type {IRecursoTransferenciaSolicitacao} from "@models/recurso/IRecursoTransferencia.ts";
import {Button, Grid, Typography} from "@mui/material";
import {ToMoney} from "@shared/MathHelp.ts";
import {createSearchParams, useNavigate} from "react-router";

interface TransferenciarecursoAprovacaoProps {
	transferencia: IRecursoTransferenciaSolicitacao;
}

export const TransferenciaRecursoSolicitacao: React.FC<TransferenciarecursoAprovacaoProps> = ({transferencia}) => {
	const navigate = useNavigate();
	
	
	return (
		<Grid container>
			<Grid>
				<Typography height={'100%'}
				            paddingTop={0.5}>
					{transferencia.id} {transferencia.recursoId} {transferencia.recurso?.nome} {transferencia.orcamentoOrigemId} {ToMoney(transferencia.valorSolicitado)} {transferencia.statusAprovacao}
				</Typography>
			</Grid>
			<Grid>
				<Button onClick={() => navigate({
					pathname: _Sitemap.recurso.children.transferencias.children.detalhes.fullUrl,
					search: createSearchParams({
						transferenciaId: transferencia.id.toString(),
					}).toString(),
				})}
				>Ir para</Button>
			</Grid>
		</Grid>
	);
};